module.exports = __webpack_public_path__ + "static/media/sample_management.d6ff5a13.svg";